import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex-basis-30" }
const _hoisted_2 = { class: "_flexcol _gap-2 _grow-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['_pa-3 _pos-r _bgc--white _rounded--common gfu-background-swept _gap-3', $options.variantClasses]),
    "data-qa": "project-card-skeleton"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_skeleton_image)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_skeleton_line),
      _createVNode(_component_skeleton_line, { height: 28 }),
      _createVNode(_component_skeleton_line, { class: "_mb-4" }),
      _createVNode(_component_skeleton_line)
    ])
  ], 2 /* CLASS */))
}